module.exports = __webpack_public_path__ + "static/media/volunteer.f3165969.svg";